module.exports = __webpack_public_path__ + "static/sport/title.e3138da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/title.png
// module id = z8t6
// module chunks = 0